export default __webpack_public_path__ + "static/media/pngkit_call.be10b6a1.png";